import React, { useState } from 'react';

import { FilterIcon } from '../../../icons'

import {
    Box,
    Drawer,
    Button,
    Typography,
    IconButton,
    useMediaQuery,
    useTheme,
    InputLabel,
    Avatar,
    Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FilterwIcon} from '../../../icons';

import FilterListIcon from '@mui/icons-material/FilterList';


import SingleSelectDroupdown from '../../../components/Projects/project-components/SingleSelectDroupdown';
import TeamSelectDroupDown from '../../../components/Projects/project-components/TeamSelectDroupDown';

import MultiClientSelect from '../../../components/DemoTabs/MultiClientSelect';

import ClientImageSelect from '../../../components/DemoTabs/ClientImageSelect';
import ActivityLevel from '../../../components/DemoTabs/ActivityLevel';
import SelectDropDowns from '../../../components/DemoTabs/SelectDropDowns';




const ManualTimeFilter = () => {

    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 



    // Project Seclect Single 
    const [selectedTeamsAll, setSelectedTeamsAll] = useState(null);
    // Project Seclect Single 


    // start Projects 
    const [selectedClients, setSelectedClients] = React.useState([]);
    const allClients = [
        { name: 'Client Name 1', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Client Name 2', image: null },
        { name: 'Client Name 3', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Client Name 4', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Client Name 5', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Client Name 6', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];
    // End Projects 

    // start Members 

    const [selectedUsers, setSelectedUsers] = useState([]);

    const users = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];


   // start Change 

    const [selectedChange, setSelectedChange] = useState([]);

    const Change = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];



// start Time worked 
    const [selectedActions, setSelectedActions] = useState('');

    const ActionsData = [
        { name: 'Select' },
        { name: 'Add' },
        { name: 'Edit' },
        { name: 'Delete' },
        { name: 'Move' },

    ];

    // End  Time worked 



    // start Time worked 
    const [selectedTimeWorked, setSelectedTimeWorked] = useState('');

    const TimeWorkedData = [
        { name: 'Select' },
        { name: 'With time tracked' },
        { name: 'With no time tracked' },
    ];

    // End  Time worked 



    // export default function FilterPopup() {
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const DrawerContent = (
        <Box sx={{ width: isMobile ? '100vw' : 360, height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fff', borderRadius: isMobile ? 0 : '0 0 0 0' }} role="presentation">
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center"
                sx={{ p: '24px', borderBottom: '1px solid #D0D4E4', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                <Typography fontSize={'22px'} fontWeight={700} sx={{fontFamily:'Manrope'}}>Filter</Typography>
                <IconButton onClick={toggleDrawer(false)} sx={{ p: 0 }}>
                    <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                </IconButton>
                <Box onClick={toggleDrawer(false)}
                    style={{
                        position: 'absolute', backgroundColor: '#fff', borderRadius: '100px', boxShadow: '0px 1px 6px 2px #00000030', height: '32px',
                        width: '32px', display: 'flex', justifyContent: 'center', alignItems: 'center', left: '-12px', bottom: '-16px', cursor: 'pointer',
                        zIndex: 10,
                    }}>
                    <ChevronRightIcon fontSize="small" />
                </Box>
            </Box>

            {/* Body */}
            <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 3 }}>
                {/* <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Client</InputLabel>
                    <ClientImageSelect label="All Clients" options={allClients} selectedValues={selectedClients} onChange={setSelectedClients} />
                </Box> */}

                {/* start Projects sec  */}
                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Projects</InputLabel>
                    <SingleSelectDroupdown
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                    />
                </Box>
                {/* End Projects sec  */}

                  {/* start Time Worked */}
                <Box sx={{ pb: 2, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Actions</InputLabel>
                    <SelectDropDowns label="All Actions" options={ActionsData} selectedValue={selectedActions} onChange={setSelectedActions} />
                </Box>

                {/* End Time Worked */}


                {/* start Teams sec  */}
                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Teams</InputLabel>
                    <TeamSelectDroupDown
                        selectedTeamsAll={selectedTeamsAll}
                        setSelectedTeamsAll={setSelectedTeamsAll}
                    />
                </Box>
                {/* End Teams sec  */}


                {/* start Members sec  */}

                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Members</InputLabel>
                    <MultiClientSelect label="Select Team Members" options={users} selectedValues={selectedUsers} onChange={setSelectedUsers} />
                </Box>


                {/* End Members sec  */}

                {/* start Members sec  */}

                <Box sx={{ pb: 0, }}>
                    <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Change By</InputLabel>
                    <MultiClientSelect label="All Members" options={Change} selectedValues={selectedChange} onChange={setSelectedChange} />
                </Box>


                {/* End Members sec  */}

            </Box>

            {/* Footer */}
            <Box
                sx={{
                    p: isMobile ? 2 : '24px 30px',
                    borderTop: '1px solid #DFDFDF',
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: 2,
                    justifyContent: 'center',
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 1
                }}
            >
                <Button onClick={toggleDrawer(false)} variant="outlined" fullWidth={isMobile}
                    sx={{ backgroundColor: '#fff', textTransform: 'capitalize', color: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: 500, height: '50px', border: '1px solid #9095A1', borderRadius: '8px', fontFamily:'Manrope' }}>
                    Clear Filters
                </Button>
            </Box>
        </Box>
    );

    return (
        <>
            {/* <Tooltip title="Filter" arrow placement='top'>
                <Button onClick={toggleDrawer(true)} sx={{
                    background: '#fff',
                    borderRadius: '50px',
                    color: '#1A1F36',
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    width: '40px',
                    height: '38px',
                    border: '1px solid #E5E8EB',
                    '&:hover': {
                        background: '#f5f5f5'
                    }
                }}><FilterIcon /></Button>
            </Tooltip> */}

            {/* <Button onClick={toggleDrawer(true)} sx={{
                gap: '10px', fontFamily: 'Manrope',
                background: '#fff',
                borderRadius: '50px',
                color: '#64748B',
                fontSize: '14px',
                textTransform: 'Uppercase',
                fontWeight: '500',
                height: '36px',
                border: 'none',
                padding: '8px 16px',
                border: '1px solid #E5E8EB',
                marginRight: '-14px',
                '&:hover': {
                    background: '#0076FE',
                    borderColor: '0076FE',
                    color: '#fff'
                }
            }}><FilterListIcon sx={{ fontSize: '18px',fontFamily:'Manrope' }} />Filter</Button> */}



            <Button onClick={toggleDrawer(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none',}}
                        tabIndex={-1} startIcon={<FilterwIcon />}>
                        Filter
                      </Button>
            <div>
            <Drawer
                    anchor="right"
                    open={open}
                    onClose={toggleDrawer(false)}
                    PaperProps={{
                        sx: {
                            width: isMobile ? '100vw' : 360,
                            borderRadius: isMobile ? 0 : '0 0 0 0',
                            overflow: 'visible',
                        }
                    }}
                >
                    {DrawerContent}
                </Drawer>
               </div>
            
        </>



    );
}

export default ManualTimeFilter;
